import React from 'react';
import { Button, Menu, FormGroup, FormControlLabel, Switch } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { ClassroomSettings } from '../../../types/session';

export type MenusOption = 'strokeOrder' | 'writingGrid' | 'copybook';

type MenusProps = {
    title?: string;
    startIcon?: React.ReactNode;
    value?: ClassroomSettings;
    onClose?: () => void;
    onSettingToggle?: (option: MenusOption, checked: boolean) => void;
};

export function ClassroomMenus({ title, startIcon, value, onClose, onSettingToggle }: MenusProps) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        if (onClose) {
            onClose();
        }
    };

    return (
        <div>
            <Button
                sx={[
                    { pl: 2 },
                    (theme) =>
                        theme.applyStyles('light', {
                            '&:hover': {
                                backgroundColor: (theme.vars || theme).palette.grey[200],
                            },
                        }),
                ]}
                disableElevation
                onClick={handleClick}
                startIcon={startIcon}
                endIcon={<ArrowDropDownIcon />}
            >
                {title}
            </Button>
            <Menu
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <FormGroup sx={{ mx: 1 }}>
                    <FormControlLabel
                        control={<Switch checked={!value?.freeStyleMode} onChange={(e) => onSettingToggle && onSettingToggle('strokeOrder', !e.target.checked)} />}
                        label={t('classroom.config.writing.strokeOrder')}
                    />
                    <FormControlLabel
                        control={<Switch checked={value?.writingHints} onChange={(e) => onSettingToggle && onSettingToggle('copybook', e.target.checked)} />}
                        label={t('classroom.config.writing.copybook')}
                    />
                    <FormControlLabel control={<Switch disabled />} label={t('classroom.config.writing.writingGrid')} />
                </FormGroup>
            </Menu>
        </div>
    );
}
